import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import './header.css';

const Header = () => {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, []);

  return (
    <div className="header">
      <input type="checkbox" id="chek" />
      <label htmlFor="chek"><i className="fa-solid fa-bars"></i></label>
      <Link className="logo" to="/">PicAura</Link>
      <nav>
        <Link to="/">Home</Link>
        <Link to="/about">About</Link>
        
      </nav>
      <Link to="/login" className="btn">Sign Up</Link>
    </div>
  );
};

export default Header;
